import { JurisdictionId } from '../../types/jurisdiction';

export interface IJurisdictionState {
  activeId: JurisdictionId;
  // Jurisdictions the logged-in user is allowed to select. Defaults to the most
  // restrictive set (US-only) until the backend responds.
  allowedIds: JurisdictionId[];
}

export const SET_JURISDICTION = 'SET_JURISDICTION';
export const SET_ALLOWED_JURISDICTIONS = 'SET_ALLOWED_JURISDICTIONS';

interface ISetJurisdiction {
  type: typeof SET_JURISDICTION;
  payload: JurisdictionId;
}

interface ISetAllowedJurisdictions {
  type: typeof SET_ALLOWED_JURISDICTIONS;
  payload: JurisdictionId[];
}

export type JurisdictionActionTypes = ISetJurisdiction | ISetAllowedJurisdictions;
